import { WSAlert } from "@wingspanhq/fe-component-library";
import { queriesPayers } from "@query";
import { TaxYear } from "../../../shared/constants/taxYear";
import { selectorCounterpartyDisplayName } from "../../../shared/selectors/selectorCounterpartyDisplayName";
import { PATH_ONBOARDING_VERIFICAIONS_TAX } from "../../Onboarding";
import { useHistory } from "react-router-dom";
import { useTaxVerificationVersion } from "../../../shared/hooks/useTaxVerificationVersion";
import { ConfirmTaxInformationForLegacyUserAlert } from "./ConfirmTaxInformationForLegacyUserAlert";

export const ConfirmTaxInformationForLegacyUserAlertWithClients: React.FC<{
  currentYear: TaxYear;
  showWithNoPayer?: boolean;
}> = ({ currentYear, showWithNoPayer = false }) => {
  const history = useHistory();
  const { isLegacyOnlyTaxVerification, isLoading } =
    useTaxVerificationVersion();

  const queryAllPayers = queriesPayers.listPayers.useQueryAll(undefined, {
    enabled: isLegacyOnlyTaxVerification
  });

  // TODO (v3-migration): this matched clients on payerSettings.taxFilingSettings.
  // Per the V3 design (PLA-3198 #5) PayerSettings is not exposed on the payee's
  // Payer surface, so it can't be read off the Payer here — re-source from the
  // tax/settings domain. No client matched meanwhile.
  const payer = (queryAllPayers.flatData ?? []).find(() => false);

  if (!queryAllPayers.isFetched || isLoading || !isLegacyOnlyTaxVerification) {
    return null;
  }

  if (payer) {
    const payerName = selectorCounterpartyDisplayName(payer);

    return (
      <WSAlert
        title="Confirm your tax information"
        theme="warning"
        icon="alert"
        action={{
          text: "Confirm tax information",
          onClick: () => {
            history.push(PATH_ONBOARDING_VERIFICAIONS_TAX);
          }
        }}
      >
        {payerName} is preparing to file your 1099 tax form and needs you to
        re-verify your W-9 information. The verification system has been
        upgraded and this is a one-time confirmation to ensure your information
        is accurate and complete.
      </WSAlert>
    );
  } else if (showWithNoPayer && !payer) {
    return <ConfirmTaxInformationForLegacyUserAlert />;
  }

  return null;
};
